import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function DoubleInsurance() {
    const [reg, setReg] = useState('')
    const [chassis, setChassis] = useState('');
    const [message, setMessage] = useState('');
    const [commencementDate, setCommencementDate] = useState(null)
    const [expiryDate, setExpirydate] = useState(null)
    const [doubleInsurancestatusLoading, setDoubleinsuranceloading] = useState(0)
    const [doubleInsurancestatus, setDoubleinsurancestatus] = useState(false)
    const [checkText, setChecktext] = useState('CHECK')
    const [doubleinsuranceMessage, setDoubleinsuracemessage] = useState('')
    const [certNo, setCertno] = useState('')
    const [company, setCompany] = useState('')
    const [endDate, setEnddate] = useState('')
    const [chas, setChas] = useState('')
    const [reg2, setReg2] = useState('')
    const [coverData, setCoverdata] = useState([])
   

    function formatDateFromMilliseconds(milliseconds) {
        const date = new Date(milliseconds);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        
        
        return `${day}/${month}/${year}`;
    }

    useEffect(()=>{
        const today = Date.now().toString();
        const endMilliseconds = parseInt(today)+31536000000;
        setCommencementDate(formatDateFromMilliseconds(parseInt(today)))
        setExpirydate(formatDateFromMilliseconds(endMilliseconds))


    },[])

    const checkDoubleinsurance =async()=>{
        setChecktext('Checking....')
        const res = await Axios.post('https://sms.definiteassurance.com/webhook/d6c9608b-cd90-481a-995d-d40c908c96db',{
            chasis:chassis,reg,commence:commencementDate,end:expiryDate
        })
        setChecktext('CHECK')
        setDoubleinsuranceloading(1)
        if(res.data.success){
            setDoubleinsurancestatus(true)
            setCertno(res.data.certNo)
            setCompany(res.data.company)
            setEnddate(res.data.endDate)
            setChas(res.data.chassis)
            setReg2(res.data.reg)
          
        }
        else{
            setDoubleinsurancestatus(false)
            setDoubleinsuracemessage('Vehicle has no insurance')
        }
    }



  return (
    <div>
    
        <div className="page-content">
            <ToastContainer />
            <Breadcrumbs title="Definite Assurance" breadcrumbItem={`Validate Double Insurance `} />
            <Card className="mini-stats-wid">
                <CardBody>
                    <div className="doubleBody">
                        <h4>Check Vehicle Double Insurance</h4>
                        <hr />
                        <div className="doubleInputs">
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle Registration" onChange={(e)=>{setReg(e.target.value)}}>
                                <Form.Control  className='inputSearch'   type="text" placeholder="Vehicle Registration" />
                            </FloatingLabel>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle Chassis Number" onChange={(e)=>{setChassis(e.target.value)}}>
                                <Form.Control  className='inputSearch'   type="text" placeholder="Vehicle Chassis Number" />
                            </FloatingLabel>
                        </div>
                        <Button color="success" onClick={checkDoubleinsurance}>{checkText}</Button>
                        {doubleInsurancestatusLoading == 1 &&
                        
                            <>
                                    <hr />

                                    {doubleInsurancestatus == true &&
                                    
                                        <div className="coverDetails">
                                            <p><strong>Vehicle has active cover with the following details:</strong></p>
                                            <p><strong>Registration:</strong> {reg2}</p>
                                            <p><strong>Insurer:</strong> {company}</p>
                                            <p><strong>Certificate no.:</strong> {certNo}</p>
                                            <p><strong>Chassis:</strong> {chas}</p>
                                            <p><strong>Cover expiry:</strong> {endDate}</p>

                                        
                                        </div>
                                    
                                    
                                    }
                                    {doubleInsurancestatus == false &&
                                        <div className="coverDetails">
                                             <p style={{color:'#fff',fontSize:'14px'}}>NO RECORDS AVAILABLE</p>  
                                        </div>
                                       
                                    }
                                
                                    
                                
                                
                            </>
                        
                        
                        }

                    </div>
                </CardBody>
            </Card>
        </div>
                
    </div>
  )
}
